module.exports = __webpack_public_path__ + "static/img/przybornik_okrag.caa4573f.png";